'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import {
  SERVICE_FEE_HELP_URL,
  SERVICE_FEE_PRO_HELP_URL,
  HELP_REFUND_POLICY,
  HELP_REFUND_POLICY_PRO,
  HELP_RIGHT_OF_WITHDRAWAL_PRO,
} from '../../constants/routes'
import FactBlock from './FactBlock'
import FactsSection from './FactsSection'

type Props = {
  showPro: boolean
}

type DynamicTranslationProps = (id: string, values?: Record<string, any>) => string

const PaymentsSafetySection = ({ showPro }: Props) => {
  const translate = useTranslate('trust_and_safety')
  const translatePro = useTranslate('trust_and_safety_pro')
  const dynamicTranslations: DynamicTranslationProps = showPro ? translatePro : translate

  const calculationLink = {
    'calculation-link': (chunks: string) => (
      // Disabling: to maintain the same referral policy as if it was hardcoded relative link
      // eslint-disable-next-line react/jsx-no-target-blank
      <a
        href={showPro ? SERVICE_FEE_PRO_HELP_URL : SERVICE_FEE_HELP_URL}
        target="_blank"
        data-testid="calculation-link"
      >
        {chunks}
      </a>
    ),
  }

  const refundPolicyLink = {
    'refund-policy-link': (chunks: string) => (
      // Disabling: to maintain the same referral policy as if it was hardcoded relative link
      // eslint-disable-next-line react/jsx-no-target-blank
      <a href={HELP_REFUND_POLICY} target="_blank" data-testid="refund-policy-link">
        {chunks}
      </a>
    ),
    'pro-refund-policy-link': (chunks: string) => (
      // Disabling: to maintain the same referral policy as if it was hardcoded relative link
      // eslint-disable-next-line react/jsx-no-target-blank
      <a href={HELP_REFUND_POLICY_PRO} target="_blank" data-testid="refund-policy-pro-link">
        {chunks}
      </a>
    ),
    'right-of-withdrawal-link': (chunks: string) => (
      // Disabling: to maintain the same referral policy as if it was hardcoded relative link
      // eslint-disable-next-line react/jsx-no-target-blank
      <a href={HELP_RIGHT_OF_WITHDRAWAL_PRO} target="_blank" data-testid="right-of-withdrawal-link">
        {chunks}
      </a>
    ),
  }

  return (
    <section>
      <FactsSection
        title={dynamicTranslations('buyer_protection_fee_title')}
        description={dynamicTranslations('buyer_protection_fee_description', calculationLink)}
        html
      >
        <FactBlock
          icon="guarantee"
          title={dynamicTranslations('refund_policy_title')}
          body={dynamicTranslations('refund_policy_body', refundPolicyLink)}
        />
        <FactBlock
          icon="safe"
          title={dynamicTranslations('secure_transactions_title')}
          body={dynamicTranslations('secure_transactions_description')}
        />
        <FactBlock
          icon="support"
          title={dynamicTranslations('support_title')}
          body={dynamicTranslations('support_body')}
        />
      </FactsSection>
      <FactsSection title={translate('applicable_to_all')}>
        <FactBlock
          icon="anti-spam"
          title={translate('anti_spam_title')}
          body={translate('anti_spam_body')}
        />
        <FactBlock
          icon="secure"
          title={translate('secure_data_title')}
          body={translate('secure_data_body')}
        />
        <FactBlock
          icon="risk"
          title={translate('risk_scoring_title')}
          body={translate('risk_scroring_body')}
        />
      </FactsSection>
    </section>
  )
}

export default PaymentsSafetySection
